import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useScrollTo, useSearchJokes } from '@jokerdad/hooks';
import { useMainContext } from '@jokerdad/providers';
import Searchbar from './Searchbar';
import SearchResults from './SearchResults';
import SearchToggle from './SearchToggle';

var SearchArea = function SearchArea(_ref) {
  var finalSearchTerm = _ref.finalSearchTerm,
      onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      searchResultsData = _ref.searchResultsData;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-screen overflow-hidden bg-transparent absolute top-0 right-0 z-10"
  }, /*#__PURE__*/React.createElement(Searchbar, {
    onChange: onChange,
    onSubmit: onSubmit
  }), /*#__PURE__*/React.createElement(SearchResults, {
    results: searchResultsData,
    feedbackMessage: !finalSearchTerm && 'Type something to find a joke'
  }));
};

var SearchJoke = function SearchJoke() {
  var _useState = useState(''),
      term = _useState[0],
      setTerm = _useState[1];

  var _useState2 = useState(''),
      finalTerm = _useState2[0],
      setFinalTerm = _useState2[1];

  var _useSearchJokes = useSearchJokes(finalTerm),
      data = _useSearchJokes.data;

  var scrollToBottom = useScrollTo(window.innerHeight);

  var _useMainContext = useMainContext(),
      _useMainContext$ = _useMainContext[0],
      routingDisabled = _useMainContext$.routingDisabled,
      searchOpened = _useMainContext$.searchOpened;

  var handleChange = function handleChange(e) {
    return setTerm(e.target.value);
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    setFinalTerm(term);
    scrollToBottom();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchToggle, null), !routingDisabled && /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "/search",
    element: /*#__PURE__*/React.createElement(SearchArea, {
      onChange: handleChange,
      onSubmit: handleSubmit,
      searchResultsData: data,
      finalSearchTerm: finalTerm
    })
  })), routingDisabled && searchOpened && /*#__PURE__*/React.createElement(SearchArea, {
    onChange: handleChange,
    onSubmit: handleSubmit,
    searchResultsData: data,
    finalSearchTerm: finalTerm
  }));
};

export default SearchJoke;